import React, { useState } from 'react';

export const ThemeContext = React.createContext();

export const ThemeProvider = (props) => {
  const resumeMode = import.meta.env.VITE_LANDING_PAGE_MODE || "freelance_services" == "resume";
  const [theme, setTheme] = useState(
    localStorage.getItem('portfolio-theme')
      ? JSON.parse(localStorage.getItem('portfolio-theme'))
      : null,
  );

  return (
    <ThemeContext.Provider value={[theme, setTheme, resumeMode]}>
      {props.children}
    </ThemeContext.Provider>
  );
};
